import {Enum} from "@/enums/system";
import {wdiCore} from "./wdiCore";
import * as XLSX from 'xlsx'
import {GridApi, ViewApi} from '@/services/gridapi';

const allowExportFields = (column: any, exceptNames?: string[]) => {
  if (!wdiCore.Object.IsNullOrUndefined(column) && !column.isDisabled && !column.isHidden) {
    if (exceptNames && exceptNames.indexOf(column.Name) > -1) {
      return false;
    }
    return true;
  }
  return false
}

const getFields = (formSchema: any, names: string[], exceptNames?: string[]) => {
  const fields = [];
  const allFields = formSchema.allFields;
  if (names && names.length) {
    names.forEach((item) => {
      const column = allFields[item];
      if (allowExportFields(column, exceptNames)) {
        fields.push(column);
      }
    });
  } else {
    for (let key in allFields) {
      const column = allFields[key];
      if (allowExportFields(column, exceptNames)) {
        fields.push(column);
      }
    }
  }
  return fields;
};

const defaultCellFormat = (fieldObject: any, row: any, value: any) => {
  return value;
}

const numberCellFormat = (fieldObject: any, row: any, value: any) => {
  let format = fieldObject.format;
  let cellsformat = 'd2';
  if (wdiCore.String.EqIngoreCase(fieldObject.dataType, Enum.FieldDataType.INT)) {
    cellsformat = 'd0';
  } else {
    if (!wdiCore.String.IsNullOrEmpty(format)) {
      if (/^d\d$/g.test(format) || /^p\d$/g.test(format)) {
        cellsformat = format;
      }
    }
  }
  let digits = Number(cellsformat.substring(1));
  if (wdiCore.String.EqIngoreCase(cellsformat[0], 'p')) {
    return wdiCore.Number.RateToString(value, digits);
  } else {
    return wdiCore.Number.ToString(value, digits);
  }
}

const dateCellFormat = (fieldObject: any, row: any, value: any) => {
  let format = fieldObject.format;
  let cellsformat = 'yyyy-MM-dd';
  if (!wdiCore.String.IsNullOrEmpty(format)) {
    cellsformat = format;
  }
  return wdiCore.Date.ToString(value, cellsformat);
}

const booleanCellFormat = (fieldObject: any, row: any, value: any) => {
  return wdiCore.Boolean.Display(value);
}

type ToSheetProps = {
  dataLoading?: any;
  data: any;
  names?: any[];
  exceptNames?: string[];
  cells?: {
    [key: string]: (fieldObject: any, row: any, value: any) => any;
  };
  numberColumns?: string[];
  sheetName?: string;
}


const gridToSheet = (settings: ToSheetProps, formSchema?: any) => {
  let viewNames: any[] = [];
  if (settings.names) {
    viewNames = settings.names;
  }
  let fields = viewNames;
  if (formSchema) {
    fields = getFields(formSchema, viewNames, settings.exceptNames);
  }

  const header: string[] = [];
  const firstRow: { [key: string]: string } = {};
  fields.forEach((field) => {
    const name: string = String(field.name);
    header.push(name);
    firstRow[name] = field.displayName;
  });

  const sheetBody = [];
  sheetBody.push(firstRow);

  if (settings.data) {
    settings.data.forEach((item: any) => {
      const itemRow: { [key: string]: any } = {};
      fields.forEach((field) => {

        const name: string = String(field.name);
        const cellObject = item[name];
        let cellFormat = defaultCellFormat;
        if (wdiCore.String.EqIngoreCase(field.type, Enum.FieldType.NUMBER)) {
          cellFormat = numberCellFormat;
        } else if (wdiCore.String.EqIngoreCase(field.type, Enum.FieldType.DATE_TIME)) {
          cellFormat = dateCellFormat;
        } else if (wdiCore.String.EqIngoreCase(field.type, Enum.FieldType.BOOLEAN)) {
          cellFormat = booleanCellFormat;
        }
        if (settings.cells && settings.cells[name]) {
          cellFormat = settings.cells[name];
        }

        let resultCellObject = cellFormat(field, item, cellObject);
        if (!wdiCore.Object.IsNullOrUndefined(resultCellObject)) {
          // @ts-ignore
          if (wdiCore.String.ObjectToString(resultCellObject)?.length > 10000) {
            console.log("出现过长字符串:", resultCellObject);
            // @ts-ignore
            resultCellObject = wdiCore.String.ObjectToString(resultCellObject).substring(0, 10000);
          }
          itemRow[name] = resultCellObject;
        }
      });
      sheetBody.push(itemRow);
    })
  }

  const sheet = XLSX.utils.json_to_sheet(sheetBody, {header: header, skipHeader: true});

  //格式化货币列
  if (settings.numberColumns && settings.numberColumns.length > 0 && sheet['!ref']) {
    const headerRange = XLSX.utils.decode_range(sheet['!ref']);
    const headerMap: any = {}; // 列名 -> 列索引（如 {姓名: 'A', 年龄: 'B'}）

    for (let c = headerRange.s.c; c <= headerRange.e.c; c++) {
      const cellAddress = XLSX.utils.encode_cell({r: 0, c}); // 表头行是第 0 行
      const headerName = sheet[cellAddress].v; // 表头名称
      headerMap[headerName] = XLSX.utils.encode_col(c); // 列索引（A/B/C...）
    }

    console.log(headerMap)

    for (let r = 2; r <= headerRange.e.r + 1; r++) { // 从第 1 行（数据行）开始
      //const index = r - 2;
      settings.numberColumns.forEach((item: any) => {
        const columnName = item;

        const col = headerMap[columnName]; //找金额列对应的Index
        const cellAddress = `${col}${r}`; // 单元格地址（如 A1、B1）
        const cell = sheet[cellAddress];
        console.log(cell);
        if (cell) {
          cell.z = '#,##0.00';
        }

        // if (settings.data[index].formNo == 'TADI231200003') {
        //   cell.z = '#,##0.00';
        //   // cell.z = '"CNY "#,##0.00';
        // } else if (settings.data[index].formNo == 'TADC250400002') {
        //   cell.z = '"TWD "#,##0.00';
        // }
      });
    }
  }

  return sheet;
}

export type ToExcelProps = {
  sheetProps: ToSheetProps[];
  name: string;
}

export const gridToExcel = (formSchema: any, settings: ToExcelProps) => {
  const wb = XLSX.utils.book_new();
  settings.sheetProps.forEach((sheetProp) => {
    const sheet = gridToSheet(sheetProp, formSchema);
    XLSX.utils.book_append_sheet(wb, sheet, sheetProp.sheetName || "data");
  })
  XLSX.writeFile(wb, settings.name);
}

export const toExcel = (settings: ToExcelProps) => {
  const wb = XLSX.utils.book_new();
  settings.sheetProps.forEach((sheetProp) => {
    const sheet = gridToSheet(sheetProp);

    //sheet['amount'].z='#,##0.00';
    // sheet['G3'].z='"$"#,##0.00';
    //对金额字段格式化（指定货币格式）
    // sheet['G2'].z = '"CNY "#,##0.00';
    // sheet['G3'].z = '"CNY "#,##0.00';
    XLSX.utils.book_append_sheet(wb, sheet, sheetProp.sheetName || "data");
  })


  XLSX.writeFile(wb, settings.name);
}

export const toExcelAdjustOrder = (settings: ToExcelProps) => {
  const wb = XLSX.utils.book_new();
  settings.sheetProps.forEach((sheetProp) => {
    const sheet = gridToSheet(sheetProp);
    XLSX.utils.book_append_sheet(wb, sheet, sheetProp.sheetName || "data");
  })
  XLSX.writeFile(wb, settings.name);
}


export enum ExportType {
  View = 1,
  All = 2
};

export const getSchemaColumns = async (schemaId: string, replaceColumns?: any, exportType?: ExportType, viewId?: number) => {
  const responseResult = await GridApi.searchConfig({id: schemaId});
  const settings = responseResult.data;
  if (viewId) {
    const viewResponseResult = await ViewApi.getViewAggr({id: viewId, formDefId: schemaId});
    if (viewResponseResult.data) {
      settings.viewObject = viewResponseResult.data.viewObject;
    }
  }
  const viewColumns: string[] = [];
  if (settings) {
    if (settings.viewObject && settings.viewObject.viewColumns) {
      viewColumns.push(...settings.viewObject.viewColumns);
    }
    if (exportType != ExportType.View) {
      if (settings.formSchema && settings.formSchema.viewFieldNames) {
        viewColumns.push(...settings.formSchema.viewFieldNames.filter(key => !viewColumns.includes(key)));
      }
    }
  }
  const columns: any[] = [];
  viewColumns.forEach(key => {
    if (replaceColumns?.[key]) {
      columns.push(...replaceColumns?.[key]);
    } else if (settings.formSchema.allFields[key] && !settings.formSchema.allFields[key].isHidden) {
      columns.push({
        name: settings.formSchema.allFields[key].name,
        displayName: settings.formSchema.allFields[key].displayName,
      });
    }
  });
  return columns;
};
